// Phase 5 (T-05): マルチテナント運用のための共有定数。
//
// 当面は単一テナント (`kawai-takefu21ss`) のみ。第二テナント受注時は
// hosting subdomain 等から動的解決する設計に切替予定（別 issue）。
//
// repository / functions / scripts で hardcode せず、必ずこの定数を参照する。
/**
 * 単一テナント運用中のデフォルト tenantId。
 *
 * - 顧客 Custom Token (`auth/issueCustomToken.ts`) はこの値を Claims に hardcode
 * - admin の Claims は T-01 migration で `kawai-takefu21ss` に書き換え済 (= 同値)
 * - Phase 5 移行期間中の旧 admin (tenantId 未設定) には fallback として使用
 *
 * 将来 multi-tenant 化したら、この定数を呼び出すコードはすべて
 * 「動的に決まった tenantId を引数で受け取る」形に置き換える。
 */
export const DEFAULT_TENANT_ID = 'kawai-takefu21ss';
//# sourceMappingURL=tenantConstants.js.map